module.exports = __webpack_public_path__ + "./fonts/Proxima-Semibold.ttf";